import styles from '../styles/Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <p>Copyright © Chris Meah. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;